import type { ApiErrorDetail } from '@acme/foundation';

const DEFAULT_BAD_REQUEST_MESSAGE = 'Некорректные данные. Проверьте поля.';

export type ParsedBadRequest = {
  message: string;
  details: Array<ApiErrorDetail>;
};

function isSubmitError(err: unknown): err is Error & {
  errorCode?: number | null;
  errorDetails?: Array<ApiErrorDetail> | null;
} {
  return (
    typeof err === 'object' &&
    err !== null &&
    'errorCode' in err &&
    (err as { errorCode?: number }).errorCode === 400
  );
}

export function parseBadRequestError(err: unknown): ParsedBadRequest | null {
  if (!isSubmitError(err)) return null;
  const message =
    err instanceof Error ? err.message : DEFAULT_BAD_REQUEST_MESSAGE;
  const details = err.errorDetails ?? [];
  return { message, details };
}
